module.exports = __webpack_public_path__ + "img/DS820A4SD_Large.a0ba255d.jpg";